import React, { useState, useEffect } from 'react';
import redirectURL from '../redirectURL'; // your API instance
import {emitDataReceived } from '../socketManager';


const CountdownTimerforbid = ({indent_id, biddingWindow, createDate, bidding_timer_ends }) => {
  const [timeLeft, setTimeLeft] = useState('00:00:00');
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const calculateTimeLeft = () => {
      if (!biddingWindow || !createDate) return '00:00';

      const [hours, minutes] = biddingWindow.split(':').map(Number);
      const localCreateDate = new Date(createDate.replace('Z', '') + '+05:30'); // IST
      const biddingEndTime = new Date(localCreateDate);
      biddingEndTime.setHours(biddingEndTime.getHours() + hours);
      biddingEndTime.setMinutes(biddingEndTime.getMinutes() + minutes);

      const currentTime = new Date();
      const difference = biddingEndTime - currentTime;

      const h = String(Math.max(Math.floor(difference / (1000 * 60 * 60)), 0)).padStart(2, '0');
      const m = String(Math.max(Math.floor((difference / (1000 * 60)) % 60), 0)).padStart(2, '0');
      const s = String(Math.max(Math.floor((difference / 1000) % 60), 0)).padStart(2, '0');

      return { h, m, s, difference };
    };

    const timer = setInterval(() => {
      const { h, m, s, difference } = calculateTimeLeft();

      if (h === '00' && m === '00' && s == '00') {
        setIsExpired(true);
        setTimeLeft('00:00:00');
        clearInterval(timer);
        if (bidding_timer_ends != 1) {
          redirectURL
            .post("/consignments/updateBiddingEnd", {
              indent_id: indent_id,
            })
            .then((resp) => {
              emitDataReceived({})
              console.log("Negotiation auto-ended (no quotes):", resp.data);
          })
            .catch((err) => {
              console.error("API Error:", err);
            });
        }
      } else {
        setTimeLeft(`${h}:${m}:${s}`);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [biddingWindow, createDate]);

  return (
    <span className="d-flex align-items-center gap-1">
      <span style={{ color: isExpired ? 'red' : 'blue' }}>
        {timeLeft}
      </span>
    </span>
  );
};

export default CountdownTimerforbid;
